var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_500",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_500)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.29204,
    cy: -2.13141,
    r: 9.9559,
    transform: "rotate(-22 6.29204 -2.13141)",
    fill: "url(#paint0_linear_1_500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.711,
    cy: 26.1303,
    r: 9.9559,
    transform: "rotate(-22 17.711 26.1303)",
    fill: "url(#paint1_linear_1_500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -2.12886,
    cy: 17.7084,
    r: 9.9559,
    transform: "rotate(-22 -2.12886 17.7084)",
    fill: "url(#paint2_linear_1_500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.8707,
    cy: 5.64398,
    r: 9.9559,
    transform: "rotate(-22 25.8707 5.64398)",
    fill: "url(#paint3_linear_1_500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_500",
    x1: -11.6276,
    y1: -51.7393,
    x2: 35.2565,
    y2: -34.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DFE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_500",
    x1: -0.208691,
    y1: -23.4775,
    x2: 46.6755,
    y2: -6.16116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DFE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_500",
    x1: -20.0485,
    y1: -31.8994,
    x2: 26.8356,
    y2: -14.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DFE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_500",
    x1: 7.95098,
    y1: -43.9639,
    x2: 54.8351,
    y2: -26.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DFE8E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.d46083f5a09e8221f0ea35db41f25278.svg";
export { ForwardRef as ReactComponent };